<template>
    <div style="width:100%">
        <Loading :value="loading" ></Loading>
        <!-- RACOURCIS -->

        <v-layout>
            <!-- DASHBOARB FACTURE -->
            <v-container fluid grid-list-md >
                <div style="width:100%">
                    <v-card tile class="pl-3 pr-3 pt-3  pb-3">
                        <v-layout row>
                            <v-flex sm3>
                                <v-card color="green darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="title">{{dataNbFact.paye}}</div>
                                                    <div>Facture(s) soldée(s)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Montant déjà versé</div>
                                                <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFact.paye) }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>

                            <v-flex sm3>
                                <v-card color="orange darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <v-layout row wrap>
                                                    <v-flex xs12>
                                                        <div>
                                                            <div class="title">{{dataNbFact.cours}}</div>
                                                            <div>Facture(s) en cours</div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <div>
                                                            <div class="title">{{ new Intl.NumberFormat().format(dataMntFact.coursPaye) }}</div>
                                                            <div>Montant déjà versé</div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>

                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Montant restant</div>
                                                <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFact.cours) }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>

                            <v-flex sm3>
                                <v-card color="blue-grey darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="title">{{dataNbFact.attente}}</div>
                                                    <div>Facture(s) en attente</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Montant restant</div>
                                                <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFact.attente) }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>

                            <v-flex sm3>
                                <v-card color="red darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="title">{{dataNbFact.impaye}}</div>
                                                    <div>Facture(s) impayée(s)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Montant restant</div>
                                                <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFact.impaye)}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout row mt-2 mb-3>
                            <v-flex sm12 class="text-xs-center">
                                <v-card class="elevation-5" style="height:550px">
                                    <h4>Statistiques de l'etat des factures de l'année en cours </h4>
                                    <v-divider class="mb-1"></v-divider>
                                    <div class="mb-2" id="chartFactureAn" style="width: 100%; height:100%">
                                    </div>

                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex sm6 class="mr-1">
                                <v-layout row>
                                    <v-flex sm12>
                                        <v-layout row class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4">
                                            <v-flex sm8>
                                                <div id="chartCommande" style="width:100%; height:100%">

                                                </div>
                                            </v-flex>

                                            <!--Commande livre -->
                                            <v-flex sm4>
                                                <v-layout row wrap class="pt-2 pl-2 pr-2 pb-2">
                                                    <v-flex sm12>
                                                        <v-card color="teal lighten-1" class="white--text elevation-5">
                                                            <v-container fluid grid-list-lg>
                                                                <v-layout row>
                                                                    <v-flex xs12>
                                                                        <div>Commande(s) livrée(s)</div>
                                                                        <div class="display-1">{{nbLivraison}}</div>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card>
                                                    </v-flex>

                                                    <v-flex sm12>
                                                        <v-card color="deep-orange lighten-1" class="white--text elevation-5">
                                                            <v-container fluid grid-list-lg>
                                                                <v-layout row>
                                                                    <v-flex xs12>
                                                                        <div>Commande(s) effectuée(s)</div>
                                                                        <div class="display-1">{{ nbCommande }}</div>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>


                                            </v-flex>

                                        </v-layout>

                                    </v-flex>
                                </v-layout>

                            </v-flex>

                            <!-- diagramme pie facture-->
                            <v-flex sm6 class="ml-1">
                                <div id="chartFacture" class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4" style="width: 100%; height:100%">

                                </div>
                            </v-flex>
                        </v-layout>

                    </v-card>
                </div>
            </v-container>
        </v-layout>

        <v-layout row class="elevation-6 pt-1 mb-3">
            <v-flex sm12  class="text-xs-center">
                <h3>Critères de recherche </h3>
                <v-divider class="mb-2"></v-divider>
                <el-form :inline="true" :model="formTri" class="demo-form-inline">
                    <el-form-item label="Période" >
                        <el-date-picker
                                style="width: 100%"
                                v-model="formTri.periode"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                type="datetimerange"
                                range-separator="à"
                                start-placeholder="Début date"
                                end-placeholder="Fin date"
                        ></el-date-picker>
                    </el-form-item>

                    <el-form-item label="">
                        <el-select filterable  clearable v-model="formTri.fournisseur" placeholder="fournisseur">
                            <el-option
                                    v-for="item in listeFournisseur"
                                    :key="item.id"
                                    :label="item.libelle"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-select clearable v-model="formTri.etat" placeholder="Etat facture">
                            <el-option
                                    v-for="item in listeEtat"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="montant (<=)">
                        <el-input-number v-model="formTri.montant" :min="1" ></el-input-number>
                    </el-form-item>

                    <el-form-item label="">
                        <v-tooltip bottom>
                            <v-btn @click="rechercheFacture()" slot="activator" class="white--text" color="blue" fab small :disabled="desactiveBout">
                                <v-icon>search</v-icon>
                            </v-btn>Effectuer une recherche
                        </v-tooltip>
                    </el-form-item>
                </el-form>
            </v-flex>

        </v-layout>

        <v-layout>

            <v-flex xs12 class="elevation-2 pt-3 pl-3 pr-3" >
                <h4 class="mt-2">LISTES DE(S) {{libeleRechFacture}}</h4>
                <v-divider class="mb-2 mt-1"></v-divider>
                <v-flex xs12 class="text-xs-right">
                    <v-tooltip top>
                    <v-btn
                        v-if="true"
                        slot="activator"
                        color="orange"
                        :disabled="false"
                        @click.stop="imprimeFacturePDF()"
                        dark
                    >
                        Imprimer
                        <v-icon right>print</v-icon>
                    </v-btn>Imprimer la liste des factures
                    </v-tooltip>
                </v-flex>
                <el-table
                        highlight-current-row
                        show-summary
                        :summary-method="getSommeFact"
                        :header-row-style="headerRowStyle"
                        ref="multipleTableFact"
                        @selection-change="handleSelectionChange"
                        :data="liteFacture" style="width:100%;">
                    <el-table-column width="55"  type="selection"></el-table-column>
                    <el-table-column prop="fournisseur" label="Fournisseur" align="left" width="130" fixed> </el-table-column>
                    <el-table-column prop="libFact" label="Libelle" align="left" width="150"  fixed>
                        <template slot-scope="scope" >
                            <span class="blue--text body-2">{{scope.row.libFact}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datePaiement" label="Date de paiement" align="center"  >
                    </el-table-column>
                    <el-table-column prop="modalite" label="Conditions de paiement" align="left" >
                    </el-table-column>
                    <el-table-column prop="etat" label="Etat" align="left" >
                        <template slot-scope="scope" >
                            <el-tag v-if="scope.row.etat == 'En attente'"  type="info">{{scope.row.etat}}</el-tag>
                            <el-tag   v-else-if="scope.row.etat == 'Payé'"  type="success">{{scope.row.etat}}</el-tag>
                            <el-tag   v-else-if="scope.row.etat == 'Impayé'"  type="danger">{{scope.row.etat}}</el-tag>
                            <el-tag   v-else-if="scope.row.etat == 'En cours'"  type="warning">{{scope.row.etat}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isPaiement" label="Paiement" align="left" >
                        <template slot-scope="scope" >
                            <el-tag v-if="scope.row.isPaiement == true"  type="success">Autorisé</el-tag>
                            <el-tag   v-else  type="info">Non-autorisé</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mntTotal" label="Montant total" align="left">
                        <template slot-scope="scope">
                            {{new Intl.NumberFormat().format(scope.row.mntTotal)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="mntPaye" label="Montant paye" align="left">
                        <template slot-scope="scope">
                            {{new Intl.NumberFormat().format(scope.row.mntPaye)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="mntRestant" label="Montant restant" align="left">
                        <template slot-scope="scope">
                            <span v-if="scope.row.mntRestant > 0" style="color: #E6A23C; font-size:16px" >{{new Intl.NumberFormat().format(scope.row.mntRestant)}}</span>
                            <span v-else  >{{new Intl.NumberFormat().format(scope.row.mntRestant)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="ACTION" align="center" fixed="right">
                        <template slot-scope="scope">
                            <v-tooltip bottom>
                                <v-btn slot="activator" @click="showDetailFacture(scope.row)" fab dark small color="blue">
                                    <v-icon dark>list</v-icon>
                                </v-btn>
                                Detail
                            </v-tooltip>
                        </template>
                    </el-table-column>

                </el-table>
            </v-flex>
        </v-layout>

        <!-- MODAL VALIDATION PAIEMENT FACTURE -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogValideFacture" persistent max-width="900">
                <v-card>
                    <v-card-title class="headline">


                        <v-chip color="primary" text-color="white">{{multipleSelection.length}}</v-chip>

                        facture(s) selectionnée(s)
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="mb-5" >
                        <el-alert
                                :title="'Voulez-vous comfirmer le paiement à la caisse des  factures selectionnées '"
                                description="Cette liste contient uniquement les factures dans le montant restant est supérieur à 0"
                                type="warning"
                                center
                                :closable="false"
                                show-icon>
                        </el-alert>

                        <!-- Listes des besoins selectionnes -->
                        <el-table
                                border
                                highlight-current-row
                                show-summary
                                :summary-method="getSommeFact"
                                :header-row-style="headerRowStyle"
                                :data="listeFactureSelect"
                                style="width: 100%; margin-top:30px">
                            <el-table-column
                                    align="center"
                                    prop="fournisseur"
                                    label="Fournisseur">
                            </el-table-column>

                            <el-table-column
                                    align="center"
                                    prop="libFact"
                                    label="Libelle">
                            </el-table-column>

                            <el-table-column
                                    align="center"
                                    prop="mntRestant"
                                    label="Montant restant">
                                <template slot-scope="scope">
                                    {{ new Intl.NumberFormat().format(scope.row.mntRestant)}}
                                </template>
                            </el-table-column>
                              <el-table-column
                                    align="center"
                                    prop="montantVerse"
                                    label="Montant à regler">
                                <template slot-scope="prop">
                                   <!-- <div class="block"> -->
                                      <el-input-number :min="1" :max="prop.row.mntRestant" name="montantVerse" placeholder="Montant à verser" v-model="prop.row.montantVerse"  style="width:100%"></el-input-number>
                                    <!-- </div> -->
                                </template>
                            </el-table-column>
                        </el-table>

                    </v-card-text>
                    <v-card-actions >
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn  flat @click.native="dialogValideFacture = false">Annuler</v-btn>
                      <v-btn   color="green darken-1" @click="validPaiem = true" flat >Confirmer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- MODAL STOP TRAVAUX-->

        <!-- MODAL DETAIL FACTURE -->
        <!-- MODAL SHOW FACTURE -->
        <v-dialog v-model="dialogShowFacture" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de la facture </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowFacture = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="14">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">

                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Identifiant : </b> {{detailFacture.ref}} </p>
                                                    <p><b>Libellé : </b> {{detailFacture.libelle}} </p>
                                                    <p><b>Référence commande : </b> {{detailFacture.refCom}} </p>
                                                    <p v-if="detailFacture.typeFact === true"><b>Commande concerné : </b> COM-{{detailFacture.id}} </p>
                                                    <p v-if="detailFacture.typeFact === false"><b>Maintenance concerné : </b> MAIN-{{detailFacture.id}} </p>
                                                    <p v-if="detailFacture.typeFact === true"><b>Date de la commande : </b> {{detailFacture.dateC}} </p>
                                                    <p><b>Total ttc de la facture : </b> {{detailFacture.total}} FCFA</p>
                                                    <p><b>Etat : </b>
                                                        <v-chip v-if="detailFacture.etat == 'Impayé'" text-color="white" label color="red">
                                                            {{detailFacture.etat}}
                                                        </v-chip>
                                                        <v-chip v-if="detailFacture.etat === 'Payé'" text-color="white" label color="green">
                                                            {{detailFacture.etat}}
                                                        </v-chip>
                                                        <v-chip v-if="detailFacture.etat === 'En cours'" text-color="white" label color="orange">
                                                            {{detailFacture.etat}}
                                                        </v-chip>
                                                        <v-chip v-if="detailFacture.etat === 'En attente'" text-color="white" label color="primary">
                                                            {{detailFacture.etat}}
                                                        </v-chip>
                                                    </p>

                                                    <p><b>Enregistré par : </b> {{detailFacture.userCreated}} </p>
                                                     <p v-if="!detailFacture.refLivraison"><b>Etat de livraison : </b>
                                                      <v-chip text-color="white" label color="red">
                                                        PAS ENCORE LIVRE
                                                      </v-chip>
                                                  </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Caisse concerné : </b> {{detailFacture.libelleCaisse}} </p>
                                                    <p v-if="detailFacture.modalite !== null"><b>Modalité de règlement : </b>
                                                        {{detailFacture.modalite}}
                                                    </p>
                                                    <p v-if="detailFacture.avance !== null"><b>Avance demarage : </b>
                                                        {{detailFacture.avance}}
                                                    </p>
                                                    <p v-if="detailFacture.datePaie !== null"><b>Date de paiement : </b> {{detailFacture.datePaie}} </p>
                                                    <p v-if="detailFacture.remarqueFact !== null"><b>Remarque : </b> {{detailFacture.remarqueFact}} </p>
                                                    <p><b>Date d'enregistrement : </b> {{detailFacture.created}} </p>
                                                    <p><b>Date de modification : </b> {{detailFacture.modified}} </p>
                                                </v-flex>


                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                                <br/>

                              <el-card class="box-card" v-if="detailFacture.refLivraison">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Identifiant livraison : </b>  {{detailFacture.refLivraison}} </p>
                                                    <p><b>Date de la livraison : </b> {{detailFacture.dateCreationLivraison}} </p>
                                                    <p><b>Livreur : </b> {{detailFacture.livreurLivraison}} </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Etat livraison: </b>
                                                        <v-chip text-color="white" label color="red" v-if="detailFacture.etatLivraison === false">
                                                            PARTIELLEMENT LIVRE<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip text-color="white" label color="green" v-if="detailFacture.etatLivraison === true">
                                                            TOTALEMENT LIVRE<v-icon right></v-icon>
                                                        </v-chip>
                                                    </p>
                                                    <p v-if="detailFacture.etatLivraison === false"><b>Quantité livré : </b> {{qteLivre}} / {{qteRestant}}</p>
                                                    <p><b>Date d'enregistrement : </b> {{detailFacture.created}}</p>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>

                        </el-col>
                        <el-col :span="10">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout wrap justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT REMISE : {{totalComRemise}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT HT : {{totalComHT}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT TVA : {{totalComTVA}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="orange" label color="orange" style="font-size:23px">
                                                        MONTANT TTC : {{new Intl.NumberFormat().format(totalTTC)}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                    <el-row>
                                        <v-layout row>
                                            <v-flex xs3 class="ml-3  elevation-5 ">
                                                <a :href="detailFacture.imagefact"  target=_blank>
                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="detailFacture.imagefact" ></v-avatar>
                                                </a>
                                            </v-flex>
                                        </v-layout>
                                    </el-row>
                                </div>
                            </el-card>

                        </el-col>
                    </el-row>

                    <el-row :gutter="7" style="padding:10px;">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="detailFacture.option" height="250" style="width: 100%">
                                            <el-table-column prop="produit" label="Description" width="180"></el-table-column>
                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                            <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                            <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                                            <el-table-column prop="tva" label="TVA(%) " width="180"></el-table-column>
                                            <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                                        </el-table>
                                    </template>
                                    <!-- <template v-if="detailFacture.option.length > 0">
                                        <el-table :data="detailFacture.option" height="250" style="width: 100%">
                                            <el-table-column prop="produit" label="Description" width="180"></el-table-column>
                                            <el-table-column prop="tva" label="TVA(%) " width="180"></el-table-column>
                                            <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                            <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                            <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                                        </el-table>
                                    </template> -->
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL DETAIL FACTURE -->

        <v-btn   style="margin-right: 10px; margin-bottom:60px;"
                absolute
                slot="activator"
                dark
                fixed
                fab
                large
                 :disabled="multipleSelection.length == 0"
                bottom
                right
                color="green"
                @click="modalValideFacture()"
        >
            <v-icon>done_all</v-icon>
        </v-btn>

     <!-- MODAL PAIEMENT -->
    <v-dialog v-model="validPaiem" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h1 align="center">Voulez-vous vraiment effectuer ce paiement ?</h1>
          <p align="center">
            <v-btn @click.native="validPaiem = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red"  @click="validFacture()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    </div>
</template>

<script>

    //var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import Loading from '@/components/Loading'

    export default {
        components: {Loading} ,
        name: "facturePaiement",
        data(){
            return {
                //data general
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,


                formTri: {},
                listeFournisseur:[],
                listeEtat: [
                    {
                        value: 0,
                        label: "Impayé"
                    },
                    {
                        value: 1,
                        label: "Payé"
                    },
                    {
                        value: 2,
                        label: "En attente"
                    },
                    {
                        value: 3,
                        label: "En cours"
                    }
                ],
                showFactureStat: false,
                multipleSelection: [],
                liteFacture: [],
                desactiveBout: false,
                dialogMontantFacture : false,
                disabledBtnValide: true,
                libeleRechFacture: "10 DERNIERES FACTURES",
                dialogValideFacture: false,
                listeFactureSelect: [],
                dialogShowFacture: false,
                validPaiem: false,
                idFournisseur: '',
                detailFacture: {},
                totalComHT : 0,
                totalTTC : 0,
                qteLivre: 0,
                qteRestant: 0,
                totalComTVA : 0,
                totalComRemise:0,
                nbCommande: 0,
                montantTotal: 0,
                montantVerse: 0,
                monVerse:  0 ,
                nbLivraison: 0,
                dataCommande:{},
                dataFactHisto:{},
                dataNbFact:{},
                dataMntFact:[]

            }
        },

        methods: {
            handleSelectionChange(val) {
                let factNull = false;
                //trier les factures dont le montants restant est superieurs a 0
                let dataFact = val.filter( (elt,index)=>{
                    if(elt.mntRestant  <= 0){
                        this.$refs.multipleTableFact.toggleRowSelection(elt);
                        factNull = true;
                    }
                    return elt.mntRestant > 0;
                })

                this.multipleSelection = dataFact
                if (this.multipleSelection.length === 0) {
                    this.disabledBtnValide= true
                } else {
                    this.disabledBtnValide = false
                }

                if(factNull == true){
                    this.$message({
                        message: "Attention, vous ne pouvez selectionner que des factures dont le montant restant est  supérieur à 0 et non-autorisé",
                        type: 'warning',
                        duration:5000
                    });
                }


            },
            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            validFacture(){
                this.loading = true;
                this.validPaiem = false
                var formdata = new FormData()
                let data = {
                    "listeFactures": this.listeFactureSelect,
                    "user": this.user.id,
                    "idFournisseur": this.idFournisseur,
                }
                let url = this.domaine + 'facture/validation/paiement'
                formdata.append("user", this.user.id);
                //formdata.append("listeFactures", JSON.stringify(this.listeFactureSelect));
                this.$http.get(url,{params:data} ).then( response => {
                    this.dialogValideFacture = false;
                    this.loadfacture()
                    this.loading = false;
                    this.$notify({
                        title: "Validation facture",
                        message: "L'opération s'est déroulée avec succès",
                        type: "success",
                        position: "top-center"
                    });




                }, error=>{
                    this.dialogValideFacture = false;
                    this.loading = false;
                    this.$message.error("Echec lors de la validation, verifiez votre connexion");
                })
            },

            showDetailFacture(item){
                this.idFournisseur = item.idfournisseur;
                this.loading = true
                let url = this.domaine + 'fournisseur/' + item.idFact + '/show/facture'
                this.$http.get(url).then(response => {

                        this.detailFacture = response.body.facture

                        //on recupere la liste des livraison
                        let tabLivraison = this.detailFacture.livre
                        let qteR = 0
                        let qteL = 0
                        for (let element in tabLivraison) {
                          let item = tabLivraison[element]
                            qteL += item.qteL
                            qteR += item.qteR
                        }
                        this.qteLivre = qteL
                        this.qteRestant = qteR +  qteL
                        let totalHT = 0
                        let totalTTC = 0;
                        let totalTVA = 0
                        let totalRemise = 0;
                        let optionFactures = this.detailFacture.option;
                        for (let option in optionFactures) {
                            let tmpTotalHTSRem = parseFloat( optionFactures[option].prix * optionFactures[option].qte)
                            let mntRemise = 0;
                            let remise = parseFloat(optionFactures[option].remise)
                            if(remise > 0){
                                mntRemise =  (tmpTotalHTSRem  * remise) /100
                            }
                            let tmpTotalHT = tmpTotalHTSRem - mntRemise;
                            let tva = parseFloat( optionFactures[option].tva);
                            let tmpTotalTVA = ((tmpTotalHT) * (tva/ 100));
                            totalTVA += tmpTotalTVA;
                            totalHT += tmpTotalHT;
                            totalRemise += mntRemise;
                        }
                        this.totalComHT = new Intl.NumberFormat().format(totalHT)
                        this.totalComTVA = new Intl.NumberFormat().format(totalTVA)
                        this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
                        this.dialogShowFacture = true;
                        this.totalTTC = totalHT + totalTVA;
                        this.loading = false

                }, error=>{
                    this.loading = false
                    this.$message.error("Echec lors Chargement detail facture, verifiez votre connexion");
                })
            },
            imprimeFacturePDF()
            {
            //  let tab = []
            //     this.listeDoc.forEach((element) => {
            //         tab.push(element.idDoc)
            //     })
                let url = this.domaine + 'facture/imprimer_facture_pdf/liste';
                window.open(url)
                },
            loadFournisseur () {
                this.loading = true
                let url = this.domaine + 'fournisseur/index'
                this.$http.get(url).then(response => {

                        this.listeFournisseur = response.body.fournisseur
                        this.loading = false

                }, err=>{
                    this.loading = false
                    this.$message.error("Echec lors Chargement liste fournisseurs, verifiez votre connexion");
                })
            },
            loadfacture(){
                this.loading = true;
                let url = this.domaine + 'facture/paiement'

                this.$http.get(url).then(response => {

                        this.liteFacture = response.body.factures;
                        this.libeleRechFacture = response.body.libRecherche
                        this.loading = false


                }, err=>{
                    this.loading = false
                    this.$message.error("Echec lors Chargement des factures, verifiez votre connexion");
                })
            },
            rechercheFacture(){
                this.loading = true;

                let url = this.domaine + 'facture/recherche'
                let data = {
                    periode: this.formTri.periode,
                    fournisseur: this.formTri.fournisseur,
                    etat: this.formTri.etat,
                    montant: this.formTri.montant
                }

                this.$http.get(url,{params:data}).then(response => {
                    this.liteFacture = response.body.factures;
                    this.idFournisseur =  this.liteFacture.idfournisseur
                    this.libeleRechFacture = response.body.libRecherche
                    this.loading = false


                }, err=>{
                    this.loading = false
                    this.$message.error("Chargement des factures, verifier votre connexion");
                })
            },
             modalConfirmeMontant(item){
               let  total = 0
                 for (let prop in item) {
                      let ligne = item[prop];
                        total += ligne.mntTotal
                    }

                this.montantTotal = total
                // this.listeFactureSelect = this.multipleSelection.slice();
                this.dialogMontantFacture= true;
            },
            modalValideFacture(){
                this.listeFactureSelect = this.multipleSelection.slice();
                this.dialogValideFacture= true;
            },
            getSommeFact(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = "Total";
                        return;
                    }

                    if (index === 3  || index === 4 || index === 6   ) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });
                return sums;
            },

            statDepenseAn(dataFactHisto) {
                var posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];


                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let  labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };


                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };


                let option = {
                    color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            mark: {show: true},
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: {show: false},
                            data: []
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [

                        {
                            name: 'Payé',
                            type: 'bar',
                            barGap: 0,
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'En cours',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'En attente',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'Impayé',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                    ]
                }; //option


                for(let datahis in dataFactHisto){
                    option.xAxis[0].data.push(datahis);
                    let series = dataFactHisto[datahis]

                    option.series[0].data.push(series["paye"]);
                    option.series[1].data.push(series["cours"]);
                    option.series[2].data.push(series["attente"]);
                    option.series[3].data.push(series["impaye"]);
                }

                //this.dataFactHisto.forEach(function(element) {
                //optionDepense.xAxis[0].data.push(element.date);
                //optionDepense.series[0].data.push(element.montant)
                //})

                let chartFactureAn = echarts.init(document.getElementById('chartFactureAn'))
                chartFactureAn.setOption(option)
            },
            statFacture(dataNbFact) {
                let posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];


                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let  labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };


                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };


                let option = {


                    title: {
                        text: "Statistique Nb facture",
                        left: 'left',

                        textStyle: {
                            color: '#000,'
                        }
                    },

                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },

                    series: [
                        {
                            name: 'Nb Facture(s)',
                            type: 'pie',
                            radius: '75%',
                            center: ['50%', '50%'],
                            color:["#388E3C","#D32F2F","#455A64","#F57C00","#00BCD4"],
                            data: [
                                // {value: 335, name: '直接访问'},
                            ]
                        }
                    ]
                };

                for(let dataFact in dataNbFact){
                    //let series = this.dataNbFact[dataFact]

                    option.series[0].data.push({value:dataNbFact[dataFact], name:dataFact });

                }

                let chartFacture = echarts.init(document.getElementById('chartFacture'))
                chartFacture.setOption(option)
            },
            statCommande(dataCommande) {
                let  posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];


                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };


                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };

                let optionComd = {
                    title: {
                        text: 'Statistique des commandes',
                        subtext: '',
                        left: 'left'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [
                        {
                            name: ['Commande(s)'],
                            type: 'pie',
                            radius: '75%',
                            center: ['50%', '60%'],
                            color:[ "#26A69A","#FF7043"],
                            data: [
                                //{value: 1548, name: '搜索引擎'}
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                for(let dataCom in dataCommande){

                    //let series = this.dataCommande[dataCom]

                    optionComd.series[0].data.push({value:dataCommande[dataCom], name:dataCom });

                }

                this.nbCommande = dataCommande["commande"];
                this.nbLivraison = dataCommande["livraison"];


                let chartCommande = echarts.init(document.getElementById('chartCommande'))
                chartCommande.setOption(optionComd)
            },
            loadAllDataCommandeStat(){
                this.loading = true
                let url = this.domaine + 'facture/stat/general'

                this.$http.get(url).then(response => {
                    this.dataCommande = response.body.dataCommande;
                    this.statCommande(this.dataCommande)
                    this.loading = false

                }, error =>{
                    this.loading = false
                })
            },

            //STATISTIQUE FACTURE
            loadAllDataFactAn(){
                this.loading = true
                let url = this.domaine + 'facture/stathisto'

                this.$http.get(url).then(response => {
                    this.dataFactHisto = response.body.dataFacture;
                    this.dataNbFact = response.body.dataNbFact;
                    this.dataMntFact = response.body.dataMntFacture;

                    this.statDepenseAn(this.dataFactHisto)
                    this.statFacture(this.dataNbFact)
                    this.loading = false

                }, error =>{
                    this.loading = false
                })
            },

        },

        mounted(){
            this.loadfacture();
            this.loadFournisseur()
            this.loadAllDataCommandeStat()
            this.loadAllDataFactAn()
        }
    }


</script>

<style scoped>

</style>
                  this.loading = false
                })
            },

        },

        mounted(){
            this.loadfacture();
            this.loadFournisseur()
            this.loadAllDataCommandeStat()
            this.loadAllDataFactAn()
        }
    }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/validationDG/facturePaiement.vue